import { HistoryEventHandler, HistoryEventTypes } from "../history";

export type ApplyFunctionCallback = (handler: HistoryEventHandler) => void;

/**
* Base class for commands.
*/
export class Command {
    public text: string;
    public elem: SVGElement;
    public timestamp: Date = new Date();

    /**
    * @returns {string}
    */
    getText() {
        return this.text;
    }

    // TODO: Should apply and unapply become protected functions doApply and doUnapply, that the main command apply/unapply call?
    //       Once everything is TypeScript, we need to see if these particular methods are called outside this file.
    /**
     * @param {module:history.HistoryEventHandler} handler
     * @param {callback} applyFunction
     * @returns {void}
    */
    apply(handler: HistoryEventHandler, applyFunction?: ApplyFunctionCallback) {
        handler && handler.handleHistoryEvent(HistoryEventTypes.BEFORE_APPLY, this);
        if (applyFunction) {
            applyFunction(handler);
        }
        handler && handler.handleHistoryEvent(HistoryEventTypes.AFTER_APPLY, this);
    }

    /**
     * @param {module:history.HistoryEventHandler} handler
     * @param {callback} unapplyFunction
     * @returns {void}
    */
    unapply(handler: HistoryEventHandler, unapplyFunction?: () => void) {
        handler && handler.handleHistoryEvent(HistoryEventTypes.BEFORE_UNAPPLY, this);
        if (unapplyFunction) {
            unapplyFunction();
        }
        handler && handler.handleHistoryEvent(HistoryEventTypes.AFTER_UNAPPLY, this);
    }

    /**
     * @returns {Element[]} Array with element associated with this command
     * This function needs to be surcharged if multiple elements are returned.
    */
    elements() {
        return [this.elem];
    }

    /**
      * @returns {string} String with element associated with this command
    */
    type() {
        return this.constructor.name;
    }

    /**
     * Attempts to merge another command with this one.
     * Returns true if the merge was successful and the other command can be discarded, otherwise false.
     * @param other The other command to merge.
     * @param newText If set, the text this command becomes.
     */
    mergeHistory(other: Command, newText?: string): boolean {
        return false;
    }

    /**
     * Returns true if this command won't actually have an effect, otherwise false.
     */
    isNoOp() {
        return false;
    }
}
